var cookies;

var getCookies = function() {
    if (cookies) {
        return cookies;
    }

    cookies = {};
    let cookie = document.cookie;

    if (cookie) {
        let parts = cookie.split(";");
        for (let part of parts) {
            if (part.indexOf("=") >= 0) {
                let keyValue = part.split("=");
                let key = keyValue[0].trim();
                let value = keyValue[1].trim();
                cookies[key] = value;
            }    
        }
    }

    return cookies;
};

var getCookie = function(name) {
    if (cookies) {
        return cookies[name];
    }
    return getCookies()[name];
};

var setCookie = function(name, value, expDays = 30) {
    let cookie = name + "=" + value + ";";
    var d = new Date();
    d.setTime(d.getTime() + (expDays*24*60*60*1000));
    cookie += " expires=" + d.toUTCString() + "; path=/; Secure;";
    document.cookie = cookie;

    // update the cookies object
    if (cookies) {
        cookies = null;
        getCookies();
    }
};

var removeCookie = function(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure;";
    if (cookies) {
        delete cookies[name];
    }
};

var removeAllCookies = function() {
    for (let key of Object.keys(getCookies())) {
        document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure;";
    }
    cookies = null;
};

export default {
    getCookie,
    getCookies,
    setCookie,
    removeCookie,
    removeAllCookies
};